<template>
  <div>
    <div class="ui active inverted dimmer" v-if="loading">
      <div class="ui text loader">{{ $t('loading') }}</div>
    </div>

    <div v-else>
      <div class="ui grid container" style="padding-top: 15px">
        <!-- {{ employee }} -->
        <div class="four wide column">
          <div class="ui grid">
            <div class="row">
              <div class="column">
                <imageComponent :object="user"
                                :sendingURL=" routeName + 's/' + getObject().id + '/add/image'">
                </imageComponent>
              </div>
            </div>

            <div class="row">
              <div class="column">

                <div class="ui grid">
                  <div class="row">
                    <div class="column">
                      <input type="file" id="attachment" style="display:none;" @change="onFileChangeForCreate">
                      <label for="attachment" class="ui left floated fluid button">
                        <i class="ui upload icon"></i>
                        {{ $t('uploadCV') }}
                      </label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="column"  style="margin-top: -20px">
                      <label for="" v-if="currentFile">
                        <strong>{{ currentFile }}</strong>
                        <a style="cursor: pointer;margin-left: 10px;" @click="saveResume()">
                          {{ $t('upload') }}
                        </a>
                      </label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="twelve wide column">
          <h4 class="ui dividing header">
            {{ $t('personalInfo') }}
          </h4>
          <abstractTable :data="userInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('contactInfo') }}
          </h4>
          <abstractTable :data="contactInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('jobInfo') }}
          </h4>
          <abstractTable :data="$auth.user().role_name === 'doctor' ? doctorJobInfo : employeeJobInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

        </div>
      </div>

      <div class="ui horizontal divider">{{ $t('otherInfo') }}</div>

      <div class="ui tabular menu">
        <a class="item" :class="{ active: currentTab === tabs.first }"
           @click="currentTab = tabs.first">
          {{ $t('reservations') }}
        </a>
      </div>

      <div v-if="currentTab === tabs.first" style="margin-top: 10px">
        <echart :chartId="'reservations'"
                :xAxisData="getXAxisData()"
                :chartStyle="'width: 100%; height: 300px'"
                :legend="chartLegend"
                :series="chartSeries">
        </echart>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    imageComponent: require('@/components/abstract_components/Image').default,
    echart: require('@/components/abstract_components/ECharts').default
  },

  data () {
    return {
      user: null,
      loading: true,
      currentFile: null,
      resume: {
        name: null,
        attachment: null
      },
      tabs: {
        first: 'reservations',
        second: 'payslips',
        third: 'cv'
      },
      currentTab: 'reservations'
    }
  },
  mounted () {
    this.loading = true
    this.$http.get(`users/${this.$auth.user().id}/${this.routeName}`).then(response => {
      this.user = response.data
      this.loading = false
    })
  },
  watch: {
    user: {
      handler: function () {
        this.$auth.fetch()
      },
      deep: true
    }
  },
  computed: {
    userInfo () {
      return {
        [this.$t('nationalId')]: this.getObject().national_id,
        [this.$t('age')]: this.getAge(this.user.data.date_of_birth),
        [this.$t('gender')]: this.getGender(this.user.data.gender),
        [this.$t('maritalStatus')]: this.getMaritalStatus(this.getObject().marital_status),
        [this.$t('address')]: this.user.data.address
      }
    },
    contactInfo () {
      return {
        [this.$t('email')]: this.user.data.email,
        [this.$t('phone')]: this.user.data.home_phone,
        [this.$t('mobile')]: this.user.data.mobile
      }
    },
    doctorJobInfo () {
      return {
        [this.$t('specialization')]: this.user.specialization.name
      }
    },
    employeeJobInfo () {
      return {
        [this.$t('jobTitle')]: this.getObject().job_title,
        [this.$t('hireDate')]: window.moment(this.getObject().hire_date).format('LLLL'),
        [this.$t('salary')]: Number(this.getObject().salary_amount) + ' E£'
      }
    },
    routeName () {
      return this.$auth.user().role_name === 'doctor'
        ? 'doctor' : 'employee'
    },
    chartSeries () {
      return [
        {
          name: this.$t(this.currentTab),
          type: 'line',
          label: {
            normal: {
              show: true
            },
            emphasis: {
              show: true
            }
          },
          lableLine: {
            normal: {
              show: false
            },
            emphasis: {
              show: true
            }
          },
          data: this.chartData()
        }
      ]
    },
    chartLegend () {
      return {}
    }
  },
  methods: {
    chartData () {
      if (this.currentTab === 'reservations') {
        let chartData = []
        window._.each(this.user.reservations, (reservation, key) => {
          chartData.push({
            value: reservation.length,
            name: key
          })
        })

        return chartData
      }
    },
    getXAxisData () {
      if (this.currentTab === 'reservations') {
        return {
          type: 'category',
          data: window._.keys(this.user.reservations)
        }
      }
    },
    getObject () {
      return !window._.isEmpty(this.user) && this.$auth.user().role_name === 'doctor'
        ? this.user.profile : this.user.profile
    },
    onFileChangeForCreate (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createFile(files[0])
    },
    createFile (file) {
      var reader = new FileReader()
      this.currentFile = file.name
      reader.onload = (e) => {
        this.resume.name = this.user.name + ' Resume'
        this.resume.attachment = e.target.result
      }
      reader.readAsDataURL(file)
    },
    saveResume () {
      this.$http.post(`user/${this.user.id}/add/resume`, { resume: this.resume })
        .then(response => {
          this.currentFile = null
          this.resume = {
            name: null,
            attachment: null
          }
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/users/Profile.vue